import * as React from 'react';
// Bootstrap Imports
import Button from 'react-bootstrap/Button';
import InfoButton from '../../common/InfoButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import Loader from '../../common/Loader';
// Highcharts
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
// Common
import moment from 'moment';
import axios from 'axios';
import AxiosConfig from '../../../utilities/AxiosConfig';
import Select from 'react-select'
import ErrorBoundary from '../../common/ErrorBoundary';
import SessionActivity from './SessionActivity';
import './loginSessions.css';
import logger from '../../../utilities/logging';

export interface PortalSessionsMetricsProps {
    
}

export interface PortalSessionsMetricsState {
    loading : boolean,
    display : boolean,
    refreshing : boolean,
    data : Array<SessionCreationRateType>,
    points : Array<any>,
    filterParams : FilterParamsType,
    filterOptions : Array<{value : string, label : string, code : number}>,
    selectedTimeRange : string,
    timeFormat : "UTC" | "Local" | string,
    dropdownText : string,
    customRange : {
        fromDate : string,
        fromTime : string,
        toDate : string,
        toTime : string
    }
    refreshKey : number,
    showDropdown : boolean,
    finalTimeFormat : "UTC" | "Local" | string,
    timesFiltered : number
}

type SessionCreationRateType = {
    Key : number,
    IntervalStart : string,
    AccessCount : number,
    PortalClientId : string
}

type FilterParamsType = {
    fromutc : Date | null,
    toutc : Date | null,
    clientId : string,
    username : string,
    ip : string,
    intervalMinutes : string
}

class PortalSessionsMetrics extends React.Component<PortalSessionsMetricsProps, PortalSessionsMetricsState> {
    ref: any = "MetricsGraph"
    constructor(props: PortalSessionsMetricsProps){
        super(props);
        this.state = {
            loading : false,
            display : false,
            refreshing : false,
            data : [],
            points : [],
            filterParams : {
                fromutc : null,
                toutc : null,
                clientId : "",
                username : "",
                ip : "",
                intervalMinutes : "",
            },
            filterOptions : [],
            selectedTimeRange : "4h",
            timeFormat : "UTC",
            dropdownText : "UTC : Last 4 hours",
            customRange : {
                fromDate : "",
                fromTime : "",
                toDate : "",
                toTime : ""
            },
            refreshKey : 0,
            showDropdown : false,
            finalTimeFormat : "UTC",
            timesFiltered : 0,
        }
    }

    getCreationRate = (loading : boolean = false, params : FilterParamsType | null = null):void => {
        this.setState({ refreshing : true, loading, points : [] });
        let url = process.env.REACT_APP_API_URL + "/api/ops/sessiontimeline";
        let config:any = {...AxiosConfig.configValue()};
        //console.log(params ? "using passed params" : "using this.state");
        config.params = params ? params : {...this.state.filterParams};
        //console.log("REQUEST PARAMS", config);
        axios.get(url, config)
        .then(response => {
            //console.log(response, response.data);
            let filterOptions: Array<{value : string, label : string, code : number}> = [];
            let filtered: Array<any> = response.data.filter((dataPoint: SessionCreationRateType) => {
                if(dataPoint.Key > 0){
                    return true;
                }else{
                    switch(dataPoint.Key){
                        case -1:
                            filterOptions.push({value : dataPoint.PortalClientId, label : `IP : ${dataPoint.PortalClientId}`, code : dataPoint.Key});
                            break;
                        case -2:
                            filterOptions.push({value : dataPoint.PortalClientId, label : `Username : ${dataPoint.PortalClientId}`, code : dataPoint.Key});
                            break;
                        case -3:
                            filterOptions.push({value : dataPoint.PortalClientId, label : `ClientId : ${dataPoint.PortalClientId}`, code : dataPoint.Key});
                            break;
                        default:
                            logger.Info({
                                EventMessage : `PortalSessionMetrics --> getCreationRate : switch statement`,
                                EventCategory : "unexpectedreturn",
                            });
                            break;
                    }
                    return false;
                }
            });
            let points: Array<any> = filtered.map((dataPoint: SessionCreationRateType) => {
                if(this.state.timeFormat === "UTC"){
                    return [Date.parse(dataPoint.IntervalStart), dataPoint.AccessCount];
                }else{//local time
                    let offset = moment().utcOffset();
                    // //console.log(offset);
                    const localTime = Date.parse(dataPoint.IntervalStart) + offset * 60000;
                    // //console.log(localTime)
                    return [localTime, dataPoint.AccessCount];// add logic here to parse date differently if local
                }
            });
            //console.log("points final value", points);
            //console.log("filter options final value", filterOptions);
            this.setState({ data : response.data, points : points, filterOptions : filterOptions, refreshKey : this.state.refreshKey + 1, finalTimeFormat : this.state.timeFormat });
        })
        .catch(error => {
            //console.log(error, error.response, error.response.data);
            AxiosConfig.handleError(error);
            logger.Error({
                EventMessage : `PortalSessionMetrics --> getCreationRate --> Error : ${JSON.stringify(error)}`,
                EventCategory : "httprequest",
            });
        })
        .finally(() => {
            this.setState({ refreshing : false, loading : false });
        })
    }

    handleDisplayToggle = (e: React.SyntheticEvent):void => {
        e.preventDefault();
        if(!this.state.display){
            this.setState({ display : true });
            this.applyFilters();
        }
    }

    changeTimeRange = (e: React.ChangeEvent<HTMLInputElement>):void => {
        this.setState({ selectedTimeRange : e.target.value });
    }

    changeTimeFormat = (e: React.ChangeEvent<HTMLInputElement>):void => {
        this.setState({ timeFormat : e.target.value });
    }

    applyFilters = (e?: React.SyntheticEvent):void => {
        e?.preventDefault();
        this.setState({ showDropdown : false });
        const s_selectedTimeRange:string = this.state.selectedTimeRange;
        const s_timeFormat: "UTC" | "Local" | string = this.state.timeFormat;
        const s_filterParams: FilterParamsType = {...this.state.filterParams};
        if(s_selectedTimeRange){
            let filterParams : {fromutc : Date, toutc : Date} = {
                fromutc : new Date(),
                toutc : new Date(),
            }
            let timeNow = new Date().getTime();
            let min = 60000;// 1000 ms in 1 sec. 1min = 60s 60 * 1000 = 60000
            let hour = min * 60;
            let day = hour * 24;
            //console.log("Calling Apply Filters");
            switch(s_selectedTimeRange){
                case "30m":
                    filterParams.fromutc = new Date(timeNow - 30 * min);
                    this.setState({ dropdownText : `${s_timeFormat} : Last 30 minutes`});
                    break;
                case "1h":
                    filterParams.fromutc = new Date(timeNow - 1 * hour);
                    this.setState({ dropdownText : `${s_timeFormat} : Last hour` });
                    break;
                case "4h":
                    filterParams.fromutc = new Date(timeNow - 4 * hour);
                    this.setState({ dropdownText : `${s_timeFormat} : Last 4 hours` });
                    break;
                case "12h":
                    filterParams.fromutc = new Date(timeNow - 12 * hour);
                    this.setState({ dropdownText : `${s_timeFormat} : Last 12 hours` });
                    break;
                case "24h":
                    filterParams.fromutc = new Date(timeNow - 24 * hour);
                    this.setState({ dropdownText : `${s_timeFormat} : Last 24 hours` });
                    break;
                case "48h":
                    filterParams.fromutc = new Date(timeNow - 48 * hour);
                    this.setState({ dropdownText : `${s_timeFormat} : Last 48 hours` });
                    break;
                case "3d":
                    filterParams.fromutc = new Date(timeNow - 3 * day);
                    this.setState({ dropdownText : `${s_timeFormat} : Last 3 days` });
                    break;
                case "7d":
                    filterParams.fromutc = new Date(timeNow - 7 * day);
                    this.setState({ dropdownText : `${s_timeFormat} : Last 7 days` });
                    break;
                case "30d":
                    filterParams.fromutc = new Date(timeNow - 30 * day);
                    this.setState({ dropdownText : `${s_timeFormat} : Last 30 days` });
                    break;
                case "custom":
                    let formattedFrom: any = moment(`${this.state.customRange.fromDate}-${this.state.customRange.fromTime}`, "YYYY-MM-DD-HH-mm");
                    formattedFrom = moment.utc(formattedFrom).format();
                    let formattedTo: any = moment(`${this.state.customRange.toDate}-${this.state.customRange.toTime}`, "YYYY-MM-DD-HH-mm");
                    formattedTo = moment.utc(formattedTo).format();
                    filterParams.fromutc = formattedFrom;
                    filterParams.toutc = formattedTo;
                    //console.log("Formatted From", formattedFrom);
                    //console.log("Formatted To", formattedTo);
                    this.setState({ dropdownText : `${this.state.timeFormat} : Custom`});
                    break;
                default:
                    logger.Info({
                        EventMessage : `PortalSessionMetrics --> applyfilters : switch statement default`,
                        EventCategory : "unexpectedresponse",
                    });
                    break;
            }
            if(s_selectedTimeRange !== "custom"){
                filterParams.fromutc?.toISOString();
                filterParams.toutc?.toISOString();
            }
            // else{
            //     if(filterParams.fromutc > filterParams.toutc){
            //         alert("Invalid Dates. From date is greater than the to date. Searching default instead");
            //     }
            // }
            let finalFilterParams:FilterParamsType = {
                ...s_filterParams, 
                toutc : filterParams.toutc, 
                fromutc : filterParams.fromutc,
                username : "",
                ip : "",
                clientId : ""
            }
            this.setState({ filterParams : {...finalFilterParams}, timesFiltered : this.state.timesFiltered + 1 });
            this.getCreationRate(false, { ...s_filterParams, ...filterParams });
        }else{
            this.getCreationRate();
        }
    }

    handleFilterSelect = (searchVal : any) => {
        //console.log("Value of searchVal", searchVal);
        let filterParams = {
            ip : "",
            username : "",
            clientId : ""
        };
        if(searchVal){
            searchVal.forEach((item: {value : string, code : number, label : string}) => {
                switch(item.code){
                    case -1:
                        filterParams.ip = item.value;
                        this.setState({ filterParams : {...this.state.filterParams, ip : item.value} });
                        break;
                    case -2 :
                        filterParams.username = item.value;
                        this.setState({ filterParams : {...this.state.filterParams, username : item.value} });
                        break;
                    case -3:
                        filterParams.clientId = item.value;
                        this.setState({ filterParams : {...this.state.filterParams, clientId : item.value} });
                        break;
                    default:
                        break;
                }
            })
            this.getCreationRate(false, {...this.state.filterParams, ...filterParams});
        }else{
            //console.log("Else statement", searchVal);
            this.setState({ filterParams : {...this.state.filterParams, ...filterParams} });
            this.getCreationRate(false, {...this.state.filterParams, ...filterParams});
        }
    }

    handleClearFilters = (e: React.SyntheticEvent) => {
        e.preventDefault();
        const emptyParamState = {
            selectedTimeRange : "",
            timeFormat : "UTC",
            dropdownText : "UTC : All",
            customRange : {
                fromDate : "",
                fromTime : "",
                toDate : "",
                toTime : ""
            }
        }
        this.setState({...this.state, ...emptyParamState});
        this.getCreationRate(false, {...this.state.filterParams, toutc : null, fromutc : null});
    }

    refreshContent = (e: React.SyntheticEvent) => {
        e.preventDefault();
        this.getCreationRate();
    }

    handleCustomRangeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        // //console.log(e.target.name, "=>", e.target.value);
        this.setState({ customRange : {...this.state.customRange, [e.target.name] : e.target.value } })
        // //console.log(this.state.customRange);
    }

    toggleDropdown = (e: React.SyntheticEvent) => {
        e.preventDefault();
        this.setState({ showDropdown : !this.state.showDropdown });
    }

    render() { 
        const { 
            filterOptions, 
            filterParams, 
            loading, 
            refreshing, 
            points, 
            display, 
            selectedTimeRange, 
            timeFormat, 
            dropdownText, 
            customRange,
            refreshKey,
            showDropdown,
            timesFiltered
        } = this.state;
        return (
            <div className="w-100 d-flex flex-column">
                <h3><i className="material-icons">show_chart</i>Metrics: </h3>
                <div className="d-flex flex-column flex-md-row w-100 justify-content-between align-items-center my-2">
                    <div className="d-flex flex-row">
                        <span className="time-range-label">Time Range: </span>
                        <Dropdown alignRight show={showDropdown}>
                            <Dropdown.Toggle as="div" id="time-select-dropdown" className="remove-dropdown-arrow ml-2">
                                <div onClick={ this.toggleDropdown } className="cursor-on-hover px-1 border border-dark">{dropdownText} (Click Refresh to update)</div>
                            </Dropdown.Toggle>
                                <Dropdown.Menu className={`${!display&&"d-none"}`}>
                                <Form className="d-flex flex-row justify-content-center align-items-center px-2" style={{width : "350px"}}>
                                    <div className="w-50">
                                        <Form.Check onChange={this.changeTimeRange} checked={selectedTimeRange === "30m"} value="30m" type="radio" label="Last 30 minutes"/>
                                        <Form.Check onChange={this.changeTimeRange} checked={selectedTimeRange === "1h"} value="1h" type="radio" label="Last hour" />
                                        <Form.Check onChange={this.changeTimeRange} checked={selectedTimeRange === "4h"} value="4h" type="radio" label="Last 4 hours" />
                                        <Form.Check onChange={this.changeTimeRange} checked={selectedTimeRange === "12h"} value="12h" type="radio" label="Last 12 hours" />
                                        <Form.Check onChange={this.changeTimeRange} checked={selectedTimeRange === "24h"} value="24h" type="radio" label="Last 24 hours" />
                                        <Form.Check onChange={this.changeTimeRange} checked={selectedTimeRange === "48h"} value="48h" type="radio" label="Last 48 hours"/>
                                        <Form.Check onChange={this.changeTimeRange} checked={selectedTimeRange === "3d"} value="3d" type="radio" label="Last 3 days" />
                                        <Form.Check onChange={this.changeTimeRange} checked={selectedTimeRange === "7d"} value="7d" type="radio" label="Last 7 days" />
                                        <Form.Check onChange={this.changeTimeRange} checked={selectedTimeRange === "30d"} value="30d" type="radio" label="Last 30 days" />
                                    </div>
                                    <Dropdown.Divider />
                                    <div className="w-50">
                                        <Form.Check onChange={this.changeTimeRange} value="custom" type="radio" label="Custom Time Range" />
                                        <p>From:</p>
                                        <Form.Control onChange={this.handleCustomRangeChange} value={customRange.fromDate} name="fromDate" size="sm" type="date" />
                                        <Form.Control onChange={this.handleCustomRangeChange} value={customRange.fromTime} name="fromTime" size="sm" type="time" />
                                        <p>To:</p>
                                        <Form.Control onChange={this.handleCustomRangeChange} value={customRange.toDate} name="toDate" size="sm" type="date" />
                                        <Form.Control onChange={this.handleCustomRangeChange} value={customRange.toTime} name="toTime" size="sm" type="time" />
                                    </div>
                                </Form>
                                <Dropdown.Divider />
                                <div className="w-100 d-flex justify-content-between align-items-center">
                                    <h6>Show time as</h6>
                                    <Form.Check onChange={this.changeTimeFormat} checked={timeFormat === "UTC"} value="UTC" type="radio" label="UTC" />
                                    <Form.Check onChange={this.changeTimeFormat} checked={timeFormat === "Local"} value="Local" type="radio" label="Local" />
                                </div>
                                <Dropdown.Divider />
                                <div className="w-100 d-flex justify-content-end align-items-center">
                                    <Button disabled={loading || refreshing} onClick={this.handleClearFilters}>Clear Filters</Button>
                                    <Button disabled={loading || refreshing} onClick={this.applyFilters}>Apply Filters</Button>
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>

                    <Button 
                        variant="outline-secondary" 
                        disabled={display} 
                        onClick={this.handleDisplayToggle} 
                        id="display-chart"
                        className="toolbar-item"
                    >
                        Display
                    </Button>
                    <i 
                        onClick={this.refreshContent} 
                        className="material-icons cursor-on-hover d-flex"
                    >
                        refresh
                    </i>
                    <div className="toolbar-item d-flex align-items-center">
                        <Select 
                            key={timesFiltered}
                            options={filterOptions} 
                            className="w-100 toolbar-item"
                            placeholder="Filter"
                            isDisabled={filterOptions.length <= 1 || loading || refreshing}
                            isLoading={loading || refreshing}
                            onChange={this.handleFilterSelect}
                            isMulti
                        />

                        <InfoButton id="filter-info" place="left">
                            <p>
                                Filter only affect Session Creation Rate data pull
                            </p>
                        </InfoButton>
                    </div>
                </div>
                {
                    display
                    ? 
                        loading 
                        ? 
                        <div style={{height : "350px"}} className="d-flex justify-content-center align-items-center">
                            <Loader title="Loading Grid..." />
                        </div>
                        :  
                        <>
                            <div className="d-flex flex-row w-100">
                                <h5 className="mr-2">Session Creation Rate</h5>
                                <InfoButton id="session-creation-info" place="right" >
                                    <p>
                                        Number of sessions created per interval during time range.
                                    </p>
                                </InfoButton>
                            </div>
                            <ErrorBoundary showError>
                                <HighchartsReact 
                                    highcharts={Highcharts}
                                    options={{
                                        title : {
                                            text : ""
                                        },
                                        series: [
                                            {
                                                name: "Session Creation Rate",
                                                type: "line",
                                                data: points,
                                            }
                                        ],
                                        xAxis : {
                                            type: "datetime",
                                            title : {
                                                text : this.state.finalTimeFormat === "Local" ? "Times shown in local time" : "Times shown in UTC"
                                            }
                                        },
                                        yAxis : {
                                            title : {
                                                text : "Sessions Created"
                                            }
                                        },  
                                        credits : {
                                            enabled : false
                                        },
                                        legend : {
                                            enabled : false
                                        },
                                    }}
                                    ref={this.ref}
                                    allowChartUpdate={true}
                                />
                            </ErrorBoundary>
                            <SessionActivity parentRefreshing={refreshing} key={refreshKey} fromutc={filterParams.fromutc} toutc={filterParams.toutc} />
                            </>
                    : 
                    null
                }
            </div>
        );
    }
}

export default PortalSessionsMetrics;